import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaTwitterSquare,
  FaLinkedinIn,
  FaPinterestSquare,
} from "react-icons/fa";

export const SOCIAL_ICONS = [
  {
    id: 1,
    type: "Facebook",
    library: <FaFacebookSquare size={25} />,
  },
  {
    id: 2,
    type: "Twitter",
    library: <FaTwitterSquare size={25} />,
  },
  {
    id: 3,
    type: "Instagram",
    library: <FaInstagramSquare size={25} />,
  },
  {
    id: 4,
    type: "LinkedIn",
    library: <FaLinkedinIn size={25} />,
  },
  {
    id: 5,
    type: "Pinterest",
    library: <FaPinterestSquare size={25} />,
  },
];
